export default {
  methods: {
    is_desktop() {
      return window.innerWidth >= 960;
    }
  },
  computed: {
    width_tiny() {
      return 90;
    },
    width_short() {
      return 120;
    },
    width_long() {
      return this.is_desktop() ? 180 : 120;
    }
  }
};
